<template>
  <v-app-bar app
             flat
             elevate-on-scroll
             disable-resize-watcher
             disable-route-watcher
             height="96px"
             color="white"
             class="mobile-app-bar text-center">
    <v-app-bar-nav-icon @click.stop="$emit('menu')"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <div class="mobile-app-bar-icons">
<!--      <a :href="$t('home.hkaa_link')" target="_blank">-->
<!--        <v-img :src="require('@/assets/logo-hkaa.png')"-->
<!--               class="hkaa-logo"-->
<!--               contain></v-img>-->
<!--      </a>-->
      <router-link :to="{name: 'Home'}"
                   class="align-self-center">
        <v-img :src="require('@/assets/logo-canteen.png')"
               class="hkiarace-logo"
               contain></v-img>
      </router-link>
    </div>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  name: 'MobileAppBar',
}
</script>

<style lang="less">
.mobile-nav-list {
  .single-level {
    .v-list-item__content {
      padding: 16px 24px;
    }
  }
}

.mobile-app-bar {
  .shopping-cart-icon {
    cursor: pointer;
    z-index: 10;
  }

  .mobile-app-bar-icons {
    display: flex;
    flex: 0 0 0;
    //position: absolute;
    //width: 87%;
    justify-content: center;
    padding-right: 5%;
    z-index: 10;
    left: 10%;
  }

  .hkaa-logo {
    max-width: 6.8em;
    max-height: 4.1em;
  }

  .hkiarace-logo {
    margin-left: 15px;
    max-width: 15.3em;
    max-height: 3.3em;
  }
}
</style>
